/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
export var ApplicationType;
(function (ApplicationType) {
    ApplicationType["Edge"] = "edge";
    ApplicationType["EdgeChromium"] = "edgeChromium";
    ApplicationType["FirstParty"] = "firstParty";
    ApplicationType["HomePage"] = "homePage";
    ApplicationType["Hub"] = "hub";
    ApplicationType["MicrosoftNews"] = "microsoftNews";
    ApplicationType["Mmx"] = "mmx";
    ApplicationType["MobileWebViews"] = "mobileWebViews";
    ApplicationType["Office"] = "office";
    ApplicationType["PartnerRemedy"] = "partnerRemedy";
    ApplicationType["Views"] = "views";
})(ApplicationType || (ApplicationType = {}));
//# sourceMappingURL=ApplicationType.js.map